/* eslint-disable react/prop-types */
import classes from "./card-slider-partner.module.scss";
import Flex from "@/components-library/layout/flex";
function CardSliderPartner({ image, onClick }) {
  return (
    <Flex
      align="center"
      direction="row"
      justify="center"
      className={classes.container}
      onClick={onClick}
    >
      <img src={image} alt="Logo" className={classes.image} />
    </Flex>
  );
}

export default CardSliderPartner;
